import { I18n } from '@ies/starling_intl';

import React from 'react';
import ReactDOM from 'react-dom';
import { hot } from 'react-hot-loader';
import { getStarlingText, guessLang } from '@hooks/index';
import { getQueryString } from '@utils/schema';
import { RedirectURL } from './constant';
import { isMobile } from '@utils/userAgent';
import './style.scss';

import App from './Container';

const ID = getQueryString('id');
if (!ID) {
  if (isMobile()) {
    window.location.replace(RedirectURL.MOBILE);
  } else {
    window.location.replace(RedirectURL.PC);
  }
} else {
  const HotApp = hot(module)(App);
  function initI18nInstance() {
    return new Promise(resolve => {
      I18n.init(
        {
          react: {
            useSuspense: false,
          },
          keySeparator: false,
          // 我们假设当前项目只有【中文】&【英文】两个语言
          resources: {},
          fallbackLng: ['en'],
        },
        resolve
      );
    });
  }

  initI18nInstance().then(async () => {
    const texts = await getStarlingText();
    const lang = await guessLang();
    await I18n.addResourceBundle(lang, 'translation', texts, true, true);
    I18n.setLang(lang);
    ReactDOM.render(<HotApp />, document.getElementById('root'));
  });
}
